<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in">
      <v-flex xs12>
        <v-card hover>
          <v-container fluid>
            <v-layout row wrap class="vertical-center-container">
              <v-spacer></v-spacer>
              <v-flex xs12 sm2 md4 class="text-xs-right">
                <v-menu
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of allPossibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages[$route.name].color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
          <v-data-table
            :items="filteredCompliances"
            :headers="headers"
            :rows-per-page-items="itemsPerPageOptions"
            :search="filterBy"
            :custom-sort="customSort"
          >
            <template slot="items" slot-scope="props">
              <table-row
                :headers="headers"
                :row="props.item"
                parent="ComplianceResource"
                :key="props.item.id"
                @openFile="downloadFile(props.item.key)"
              ></table-row>
            </template>
            <template slot="no-data">
              <div
                class="text-xs-center grey--text subheading"
              >No records for the selected criteria.</div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </transition>
  </layout-no-padding>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ComplianceService from "@/services/requests/complianceService";
import complianceHeaders from "@/modules/complianceResources/mixins/complianceHeaders";
import TableRow from "@/modules/complianceResources/complianceRow";
import models from "@/modules/complianceResources/mixins/models";
import FormatDates from "@/services/mixins/formatDates";
import { debounce } from "lodash";
export default {
  mixins: [models, FormatDates, complianceHeaders],
  data() {
    return {
      fieldChooserMenu: false
    };
  },
  methods: {
    downloadFile(key) {
      ComplianceService.downloadCompliance(key).then(async result => {
        window.open(result.data.result);
      });
    },
    getCompliances() {
      this.loadingCompliances = true;
      var payload = {
        contractorId: this.contractorId,
        vehicleId: this.vehicleId,
        driverId: this.driverId,
        filterBy: this.filterBy,
        dateRangeStart: this.dateRangeStart,
        dateRangeEnd: this.dateRangeEnd,
        resourceType: this.resourceType
      };
      ComplianceService.getCompliances(payload)
        .then(result => {
          this.loadingCompliances = false;
          this.compliances = result.data.result;
          console.log(this.compliances);
        })
        .catch(err => {
          console.log(err);
          this.loadingCompliances = false;
          this.snackError();
        });
    },
    deleteCompliance(i, compliance) {
      ComplianceService.deleteCompliance(compliance.id)
        .then(result => {
          this.$store.commit("compliance/deleteCompliance", compliance);
        })
        .catch(err => {
          //console.log("An error occured");
        });
    },
    customSort: function(items, index, isDesc) {
      if (!index) return items;
      items.sort((a, b) => {
        if (index == "dateDisp") {
          if (!isDesc) {
            return new Date(b["expiryDate"]) - new Date(a["expiryDate"]);
          } else {
            return new Date(a["expiryDate"]) - new Date(b["expiryDate"]);
          }
        } else {
          if (
            typeof a[index] !== "undefined" &&
            typeof b[index] !== "undefined" &&
            typeof a[index] !== "null" &&
            typeof b[index] !== "undefined"
          ) {
            //if(typeof a[index] !== 'undefined'){

            var discFalseResult =
              typeof a[index] == "number"
                ? b[index] - a[index]
                : a[index]
                    .toString()
                    .toLowerCase()
                    .localeCompare(b[index].toString().toLowerCase());
            var discTrueResult =
              typeof a[index] == "number"
                ? a[index] - b[index]
                : b[index]
                    .toString()
                    .toLowerCase()
                    .localeCompare(a[index].toString().toLowerCase());
            if (!isDesc) {
              // return a[index].toString().toLowerCase().localeCompare(b[index].toString().toLowerCase());
              return discFalseResult;
            } else {
              // return b[index].toString().toLowerCase().localeCompare(a[index].toString().toLowerCase());
              return discTrueResult;
            }
          }
        }
      });
      return items;
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "compliance", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "compliance", prop: "filterBy" }),
    listView: Store.getSet({ store: "compliance", prop: "listView" }),
    compliances: Store.getSet({ store: "compliance", prop: "compliances" }),
    loadingCompliances: Store.getSet({
      store: "compliance",
      prop: "loadingCompliances"
    }),
    model: Store.getSet({ store: "compliance", prop: "model" }),
    contractorId: Store.getSet({ store: "compliance", prop: "contractorId" }),
    vehicleId: Store.getSet({ store: "compliance", prop: "vehicleId" }),
    driverId: Store.getSet({ store: "compliance", prop: "driverId" }),
    dateRangeStart: Store.getSet({
      store: "compliance",
      prop: "dateRangeStart"
    }),
    dateRangeEnd: Store.getSet({ store: "compliance", prop: "dateRangeEnd" }),
    resourceType: Store.getSet({ store: "compliance", prop: "resourceType" }),
    resourceTypes: Store.getSet({ store: "compliance", prop: "resourceTypes" }),
    resourceTypeObj: Store.getSet({
      store: "compliance",
      prop: "resourceTypeObj"
    }),
    showInactive: Store.getSet({ store: "compliance", prop: "showInactive" }),
    modelFilteredCompliances() {
      const filteredCompliances = this.compliances.filter(compliance => {
        return compliance[compliance.model].active != this.showInactive 
      })
      if (!!this.model) {
        return filteredCompliances.filter(compliance => {
          return compliance.model == this.model;
        });
      } else {
        return filteredCompliances;
      }
    },
    sortedCompliances() {
      if (this.sortBy) {
        var path = this.sortBy;
        return this.modelFilteredCompliances.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == "updatedAt") {
              return 1;
            }
            return -1;
          } else {
            if (path == "updatedAt") {
              return -1;
            }
            return 1;
          }
        });
      } else {
        return this.modelFilteredCompliances;
      }
    },
    filteredCompliances() {
      if (this.sortedCompliances.length < 1) return [];
      return this.sortedCompliances.filter(compliance => {
        compliance.name = !!compliance[compliance.model]
          ? compliance[compliance.model].name
          : "-";
        compliance.modelDisp =
          compliance.model.charAt(0).toUpperCase() + compliance.model.slice(1);
        compliance.dateDisp = this.makeShortDate(compliance.expiryDate);
        var index = this.searchByAttr(
          this.resourceTypes,
          "value",
          compliance.type
        );
        compliance.typeDisp = index >= 0 ? this.resourceTypes[index].text : "-";
        return true;
      });
    }
  },
  watch: {
    contractorId(val) {
      this.getCompliances();
      if (!!val) {
        this.vehicleId = null;
        this.driverId = null;
      }
    },
    vehicleId(val) {
      this.getCompliances();
      if (!!val) {
        this.contractorId = null;
        this.driverId = null;
      }
    },
    driverId(val) {
      this.getCompliances();
      if (!!val) {
        this.vehicleId = null;
        this.contractorId = null;
      }
    },
    dateRangeStart(val) {
      this.getCompliances();
    },
    dateRangeEnd(val) {
      this.getCompliances();
    },
    resourceType(val) {
      this.getCompliances();
      this.resourceTypeObj = !!this.resourceType
        ? this.resourceTypes.filter(type => type.value == this.resourceType)[0]
        : null;
    }
  },
  mounted() {
    this.getCompliances();
  },
  components: {
    TableRow
  }
};
</script>

<style scoped>
</style>
